var App = App || {};

App.HistoryManager = (function() {

    return {
        Push: updateUrlState,
        Pop: resetUrlState
    };

    function updateUrlState(queryKey, selectedIds) {
        let urlObj = new URL(window.location.href);
        let params = urlObj.searchParams;

        let newParam = selectedIds.length > 0 ? selectedIds.join('AND') : '';

        if (params.has(queryKey)) {
            if (newParam) {
                params.set(queryKey, newParam);
            } else {
                params.delete(queryKey);
            }
        } else if (newParam) {
            params.set(queryKey, newParam);
        }

        var newUrl = urlObj.origin + urlObj.pathname;
        if (params.toString() !== '') {
            newUrl += '?' + params.toString()
        }

        history.pushState(null, null, newUrl);

        return newUrl;
    }

    function resetUrlState(queryKey) {
        let urlObj = new URL(window.location.href);
        let params = urlObj.searchParams;

        if (params.has(queryKey)) {
            params.delete(queryKey);

            var newUrl = urlObj.origin + urlObj.pathname;
            if (params.toString() !== '') {
                newUrl += '?' + params.toString();
            }

            history.pushState(null, null, newUrl);
        }
    }

})(jQuery);